const FLAG_OFFSET = 127397;

export function iso2ToFlagEmoji(iso2: string | null | undefined): string {
    if (!iso2 || typeof iso2 !== 'string') return '';
    const code = iso2.trim().toUpperCase();
    if (code.length !== 2 || !/^[A-Z]{2}$/.test(code)) return '';
    return String.fromCodePoint(code.charCodeAt(0) + FLAG_OFFSET, code.charCodeAt(1) + FLAG_OFFSET);
}

export function getCountryLabelFromIso2(iso2: string | null | undefined): string {
    if (!iso2?.trim()) return '';
    const code = iso2.trim().toUpperCase();
    try {
        const name = new Intl.DisplayNames(['es'], { type: 'region' }).of(code);
        return name ?? code;
    } catch {
        return code;
    }
}
